import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Blank Page",
      subTitle: "Extra Pages"
    }),
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md\"><div class=\"trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between\"><div class=\"trezo-card-title\"><h5 class=\"mb-0\">Content goes here!</h5></div></div><div class=\"trezo-card-content\"><p>Hello World!</p></div></div>", 1))
  ], 64))
}